"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FeatureFlag = void 0;
let FeatureFlag = exports.FeatureFlag = /*#__PURE__*/function (FeatureFlag) {
  FeatureFlag["ActivityLogShowLocation"] = "show-location-change-activity";
  FeatureFlag["CustomFieldSorting"] = "custom-field-sorting";
  FeatureFlag["IssuesBulkImportBatchRequests"] = "issues-bulk-import-batch-requests";
  FeatureFlag["ShowReferenceCountInIssueTable"] = "show-reference-count-in-issues-table";
  FeatureFlag["IssueDetailReportSheetOverview"] = "issues-quick-reports-panel-sheet-overview-option";
  FeatureFlag["EnableBcfImport"] = "enable-bcf-import";
  FeatureFlag["UseReactQuery"] = "use-react-query";
  FeatureFlag["EnableDeletedIssuesSpace"] = "enable-deleted-issues-space";
  FeatureFlag["DeleteWithComment"] = "delete-with-comment";
  FeatureFlag["RestoreDeletedIssues"] = "restore-deleted-issues";
  FeatureFlag["DontDeleteIssueMarkups"] = "dont-delete-issue-markups";
  FeatureFlag["LocalizedNumericValues"] = "localized-numeric-value-display-in-custom-field";
  FeatureFlag["OutdatedComponentMigrationPhase1Batch1"] = "outdated-component-migration-select-box-batch-1";
  FeatureFlag["OutdatedComponentMigrationPhase1Batch2"] = "outdated-component-migration-select-box-batch-2";
  FeatureFlag["OutdatedComponentMigrationPhase1Batch3"] = "outdated-component-migration-select-box-batch-3";
  FeatureFlag["OutdatedComponentMigrationPhase2Batch1"] = "outdated-component-migration-grouped-select-box-batch-1";
  FeatureFlag["OutdatedComponentMigrationPhase2Batch2"] = "outdated-component-migration-grouped-select-box-batch-2";
  FeatureFlag["OutdatedComponentMigrationPhase2Batch3"] = "outdated-component-migration-grouped-select-box-batch-3";
  FeatureFlag["HideEmptyRolesAndCompanies"] = "hide-empty-roles-and-companies";
  FeatureFlag["DisplayIssueThumbnailField"] = "display-issue-thumbnail-field";
  FeatureFlag["UsePinsUnlinkEndpoint"] = "use-pins-unlink-endpoint";
  FeatureFlag["SortCommentsByClientCreated"] = "sort-comments-by-client-created";
  FeatureFlag["PrepareBcfImportWithTopicIds"] = "prepare-bcf-import-with-topic-ids";
  FeatureFlag["Permissions1_1"] = "permissions-1-1";
  FeatureFlag["ShowSnapshotActivity"] = "show-snapshot-activity";
  FeatureFlag["ShowSetAsThumbnailButton"] = "show-set-as-thumbnail-button";
  FeatureFlag["ReadFromIssuePlacements"] = "read-from-issue-placements";
  FeatureFlag["EnableBcfImportForRvtModel"] = "enable-bcf-import-for-rvt-model";
  FeatureFlag["ShowAttachments"] = "should-show-attachments";
  FeatureFlag["ShowAttachmentsNewBadge"] = "should-show-attachments-new-badge";
  FeatureFlag["ReferencePickerIssuesPlugin"] = "reference-picker-issues-plugin";
  FeatureFlag["ReferencePickerSheetsPlugin"] = "reference-picker-sheets-plugin";
  FeatureFlag["ReferencePickerPlanTaskPlugin"] = "reference-picker-plan-task-plugin";
  return FeatureFlag;
}({});
//# sourceMappingURL=featureFlags.js.map